import './App.css';
import Weather from './Weather';

export default function App() {
  return (
    <div className='App'> 

    <div className="container">
      <Weather/>
      <footer>
          This project was coded by <a href='http://www.linkedin.com/in/fatimahsharafudeen'>Fatimah Sharaf</a> and it is open - sourced on <a href='https://github.com/bintsharaf/'>GitHub</a> and hosted on <a href='https://courageous-cobbler-cfd88e.netlify.app/'>Netlify</a> 
      </footer>
    </div>
    </div>
  );
}

 
